'use strict';

module.exports = {
    numericKeyboard: 1,
    symbolsKeyboard: 2,
    qwertyKeyboard: 3,
    changeLanguage: 4,
    clear: 5,
    cancel: 6,
    uppercase: 7,
    backspace: 8,
    done: 13,
    space: 32,
    moveCaretToLeft: 37,
    moveCaretToRight: 39,
    moveCaretToStart: 40,
    moveCaretToEnd: 41
};
